import { poisBountyAssets } from "assets/cdn";
import classNames from "classnames";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useGoogleAnalyticsContext } from "contexts";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import useBreakpoints from "hooks/useBreakpoints";
import { useEffect } from "react";
import { onClosePopUp, selectPoisBountyV3State } from "redux/slices";
import { Carousel, Grid, itemsV2 } from "../../PB-common/learn-more-ftue";
import {
	Alignment,
	Avatar,
	Background,
	Body,
	Button,
	Container,
	Copy,
	Footer,
	Head,
	Note,
	Title
} from "./styles";

interface PBFTUEV2Props {}

export const PBFTUEV2: React.FC<PBFTUEV2Props> = () => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const { isSmDown } = useBreakpoints();
	const scale = useCalculateScale(isSmDown ? 458 : 1010, 696);
	const { trackers } = useAppSelector(selectPoisBountyV3State);
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		reportEvent("tutorial_clicked", {
			source: "pois_bounty_menu",
			pois_bounty_id: trackers?.eventId
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "tutorial_clicked",
			event_type: "pois_bounty",
			action: "tutorial_clicked",
			source: "pois_bounty_menu",
			event_id: trackers?.eventId
		});
	}, []);

	return (
		<Container scale={scale} className={classNames(isSmDown && "mobile")}>
			<Head className="head">
				<Background src={getImage(poisBountyAssets.v2.ftue.background)} />
				{isSmDown ? (
					<Title
						className="avatar-title"
						src={getImage(poisBountyAssets.v2.ftue.logo)}
					/>
				) : (
					<Avatar
						className="avatar"
						src={getImage(poisBountyAssets.v2.ftue.logo)}
					/>
				)}
			</Head>
			<CloseIconButton onClose={onClose} />
			<Alignment className="alignment">
				<Body>
					{isSmDown ? <Carousel items={itemsV2} /> : <Grid items={itemsV2} />}
				</Body>
				<Footer>
					<Copy className="copy">
						<Note className="note">Please Note:</Note>
						<br />
						<strong>
							Loyalty points are not being deducted for Poi’s Bounty
							progression.
						</strong>{" "}
						Only Loyalty Points accumulated during the sale are counted towards
						your progression.
					</Copy>
				</Footer>
			</Alignment>
			<Button
				className="button"
				themeColor="secondary"
				onClick={() => dispatch(onClosePopUp())}
			>
				Continue Shopping
			</Button>
		</Container>
	);
};
